export default function Pricing() {
  const tours = [
    {
      name: 'Tour 2 Đảo',
      duration: '6 ngày',
      islands: 'Oahu + Đảo Lớn',
      prices: [
        { type: 'Nhập đoàn tại Mỹ', price: '1,990', highlight: false },
        { type: 'Vé từ Việt Nam', price: '3,290', highlight: true }
      ],
      features: [
        'Vé liên đảo Oahu - Đảo Lớn',
        'Khách sạn 4* & AirBnB',
        'Xe tự lái 7-8 chỗ',
        'Ăn sáng + tối',
        'Vé tham quan',
        'Show Polynesian'
      ],
      color: 'from-blue-600 to-cyan-500',
      popular: false
    },
    {
      name: 'Tour 3 Đảo',
      duration: '9-10 ngày',
      islands: 'Oahu + Đảo Lớn + Maui',
      prices: [
        { type: 'Nhập đoàn tại Mỹ', price: '2,790', highlight: false },
        { type: 'Vé từ Việt Nam', price: '3,990', highlight: true }
      ],
      features: [
        'Vé liên đảo 3 đảo',
        'Khách sạn 4* & AirBnB',
        'Xe tự lái 7-8 chỗ',
        'Ăn sáng + tối',
        'Vé tham quan',
        'Show Polynesian',
        'Hana Road',
        'Haleakalā'
      ],
      color: 'from-teal-600 to-green-500',
      popular: true
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-white to-[#eff6ff]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Chi phí <span className="text-[#2563eb]">Tour Hawaii 2026</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Giá tour trọn gói - Ưu đãi đặc biệt cho nhóm đăng ký sớm
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Tour 2 Đảo */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
            <div className="bg-gradient-to-r from-[#2563eb] to-[#3b82f6] p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-2">Tour 2 Đảo</h3>
              <p className="text-blue-100">Oahu + Đảo Lớn (Big Island)</p>
              <div className="mt-4 text-sm bg-white/20 rounded-full px-4 py-1 inline-block">
                5 Ngày 4 Đêm
              </div>
            </div>

            {/* Pricing */}
            <div className="p-8">
              <div className="space-y-4 mb-8">
                <div className="flex justify-between items-center pb-4 border-b border-gray-200">
                  <span className="text-gray-600">Nhập đoàn tại Mỹ</span>
                  <span className="text-2xl font-bold text-[#2563eb]">1.990 USD</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Bay từ Việt Nam</span>
                  <span className="text-2xl font-bold text-[#2563eb]">3.290 USD</span>
                </div>
              </div>

              {/* Features */}
              <div className="space-y-3 mb-8">
                {tours[0].features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-gray-700">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl mr-3"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              {/* CTA Button */}
              <a
                href="#final-cta"
                className="block w-full py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
              >
                Đăng ký Tour 2 Đảo
              </a>
            </div>
          </div>

          {/* Tour 3 Đảo */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 relative">
            <div className="absolute top-4 right-4 bg-yellow-400 text-[#1e40af] px-4 py-1 rounded-full text-sm font-bold z-10">
              Phổ biến nhất
            </div>
            <div className="bg-gradient-to-r from-[#1e40af] to-[#2563eb] p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-2">Tour 3 Đảo</h3>
              <p className="text-blue-200">Oahu + Đảo Lớn + Maui</p>
              <div className="mt-4 text-sm bg-white/20 rounded-full px-4 py-1 inline-block">
                7 Ngày 6 Đêm
              </div>
            </div>

            {/* Pricing */}
            <div className="p-8">
              <div className="space-y-4 mb-8">
                <div className="flex justify-between items-center pb-4 border-b border-gray-200">
                  <span className="text-gray-600">Nhập đoàn tại Mỹ</span>
                  <span className="text-2xl font-bold text-[#2563eb]">2.790 USD</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Bay từ Việt Nam</span>
                  <span className="text-2xl font-bold text-[#2563eb]">3.990 USD</span>
                </div>
              </div>

              {/* Features */}
              <div className="space-y-3 mb-8">
                {tours[1].features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-gray-700">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl mr-3"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              {/* CTA Button */}
              <a
                href="#final-cta"
                className="block w-full py-4 bg-gradient-to-r from-[#1e40af] to-[#2563eb] text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
              >
                Đăng ký Tour 3 Đảo
              </a>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-2xl p-8 border-2 border-yellow-200">
          <div className="flex items-start">
            <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
              <i className="ri-gift-line text-blue-900 text-2xl"></i>
            </div>
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Ưu đãi đặc biệt</h4>
              <p className="text-gray-700 leading-relaxed">
                <strong>Giảm 5%</strong> cho nhóm từ 8 người trở lên • <strong>Giảm 3%</strong> khi đăng ký trước 3 tháng • 
                <strong> Tặng bảo hiểm du lịch</strong> trị giá $50 • <strong>Miễn phí</strong> tư vấn visa Mỹ
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#final-cta"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-yellow-400 to-orange-500 text-[#1e40af] rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            Nhận giá & ưu đãi tháng này
          </a>
        </div>
      </div>
    </section>
  );
}
